export const resizeMessageType = 'REVENI_IFRAME_RESIZE'
